<template>
  <div>
    <div>
      <label class="label">Please select a quote</label>
      <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
        :columns="columns"
        :page-index="filter.pageIndex"
        :page-size="filter.pageSize"
        :total-rows="totalRows"
        :sort-column="filter.sortColumn"
        :sort-order="filter.sortOrder"
        @pageChanged="onPageChange"
        :show-pagination="false"
        @sort="sort">
        <tr v-for="(entity, index) in quotes"
          :key="entity.quoteNo"
          :class="{ 'is-selected' : selectedRow === index }"
          @click="highlightSelected(index, $event)">
          <td>
            {{ entity.quoteNoRef }}
          </td>
          <td>
            {{ entity.regoNo }}
          </td>
          <td>
            {{ entity.make }}
          </td>
          <td>
            {{ entity.model }}
          </td>
          <td>
            {{ entity.claimNo }}
          </td>
          <td>
            {{ entity.jobStageText }}
          </td>
        </tr>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <span icon="icon is-large">
                <i class="mdi mdi-48px mdi-emoticon-sad" />
              </span>
              <p>Nothing</p>
            </div>
          </section>
        </template>
      </bulma-table>
    </div>
    <span class="has-text-danger"
      v-if="invalidQuoteId">
      <span class="icon has-text-danger">
        <i class="mdi mdi-alert-octagram mdi-24px" />
      </span>
      Please select a quote before continuing.
    </span>
  </div>
</template>

<script>
import BulmaTable from '@/components/BulmaTable'
import { QuoteColumns } from './columns'

export default {
  name: 'LoadQuoteAssign',
  inject: ['$vv'],
  components: {
    BulmaTable
  },
  props: {
    value: null,
    ecomType: {
      type: String
    },
    regoNo: {
      type: String,
      default: ''
    },
    quotes: null
  },
  data() {
    return {
      selectedRow: null,
      filter: {
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: 10
      },
      innerValue: this.value
    }
  },
  computed: {
    columns() {
      return QuoteColumns
    },
    $v() {
      return this.$vv || this.$v
    },
    invalidQuoteId() {
      return this.$v.loadOptions.quoteId.$error && !this.value.isCreateQuote
    },
    totalRows() {
      return this.quotes?.length > 0 ? this.quotes.length : 0
    }
  },
  watch: {
    innerValue: function (newVal, oldVal) {
      this.$emit('input', newVal)
    }
  },
  mounted() {},
  methods: {
    highlightSelected(index, event) {
      this.selectedRow = index
      this.innerValue.quoteId = this.quotes[index].quoteId
      this.innerValue.customerId = this.quotes[index].customerId
      this.innerValue.originalCustomerId = this.quotes[index].customerId
      this.innerValue.vehicleId = this.quotes[index].vehicleId
      if(this.ecomType == 'audanet') {
        this.innerValue.isAssignQuote = true
        this.innerValue.isOverwriteQuote = true
      }
    },
    onPageChange(pageIndex) {},
    sort() {}
  }
}
</script>
